import React from "react";
import { ManageOfferingInputSubSection } from "../../ManageOfferingInputSubSection/ManageOfferingInputSubSection";
import { ManageOfferingsBtn } from "../../ManageOfferingsBtn/ManageOfferingsBtn";
import { LiveHelpOutlined, RateReviewOutlined } from "@material-ui/icons";
import { navigateTo } from "utils/urlUtils";
import { app_route_keys } from "constants/urlPaths";
import { FEEDBACK_SECTION_KEY } from "../../OfferingFeedback/constants/OfferingFeedback.constants";
import { AddReviewBtn } from "../modules/AddReviewBtn/AddReviewBtn";
import { AddFaqBtn } from "../modules/AddFaqBtn/AddFaqBtn";
import { CustomImageHandlerLayout } from "features/ManageWebpage/modules/Customizations/common/CustomImageHandlerLayout/CustomImageHandlerLayout";
import { SeeReferenceModal } from "features/AdminPanel/modules/SeeReferenceModal/SeeReferenceModal";
import {
  CUSTOMIZATION_SECTIONKEYS,
  SECTION_TYPES,
} from "features/ManageWebpage/modules/Customizations/common/utils/Customization.constants";
import { ManageOfferingSwitch } from "../../ManageOfferingSwitch/ManageOfferingSwitch";
import { ESIGN_PLACEMENT } from "@my-scoot/exly-react-component-lib";
import { ESignPlacementSubSection } from "../modules/ESignPlacementSubSection/ESignPlacementSubSection";
import { ManageContractInputSubSection } from "../../ManageContractInputSubSection/ManageContractInputSubSection";
import { KYCTypeSubsection } from "../modules/KYCTypeSubsection/KYCTypeSubsection";
import { ManageOfferingsLockBtn } from "features/ManageOfferings/modules/ManageOfferingsLockBtn/ManageOfferingsLockBtn";
import { openPricingPage } from "utils/Utils";
import { validURLV2 } from "utils/validations";
import { KRAContractFooter } from "../modules/KRASubsection/modules/KRAContractUrlFooter/KRAContractFooter";
import { WhitelabelFeatureCard } from "../modules/WhitelabelFeatureCard/WhitelabelFeatureCard";
import {
  KYC_FREQUENCY,
  PAGE_SECTIONS_KEYS,
} from "./OfferingPageSectionsKeys.constants";
import { KycFrequencySubSection } from "../modules/KycFrequencySubSection/KycFrequencySubSection";
import { FEATURE_KEYS } from "features/Account/modules/Features/constants/FeatureKeys.constants";
import { UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL } from "features/AdminPanel/constants/AdminPanel.api";
import { cannotBeEmpty } from "common/validate";

export const PAGE_SECTIONS_TITLE = "Page Sections";

export const EVENT_PAGE_SECTION = 1;

export const PAGE_SECTIONS_TABS = [
  { label: "Event Page Details", value: EVENT_PAGE_SECTION },
  { label: "Booking Details", value: 2 },
];

export const PAGE_SECTIONS_TEXTS = {
  // About the offering
  ABOUT_OFFERINGS_TITLE: "About the offering",
  ABOUT_OFFERINGS_DESC:
    "Choose which information and how it should be displayed to viewers.",
  OFFERING_DESC_TITLE: "Expand offering description",
  OFFERING_DESC_DESC:
    "Enable this to show the full offering description by default, so users won't need to click 'Read more.'",
  OFFERING_DESC_REF_TITLE: "Expand description",
  OFFERING_DESC_REF_DESC:
    "Enable this toggle to keep the full description expanded. Long descriptions are otherwise collapsed into a snippet with a 'Read more' button to improve page readability.",
  HIDE_WORKSHOP_TITLE: "Hide workshop schedule",
  HIDE_WORKSHOP_DESC:
    "Enable this to hide the workshop schedule from the booking page, so users won't see the workshop sessions.",
  HIDE_WORKSHOP_REF_TITLE: "Workshop Schedule",
  HIDE_WORKSHOP_REF_DESC:
    "Your workshop schedule is visible to potential customers by default, allowing them to plan and adjust their schedules accordingly.",

  // Meeting Location
  MEETING_LOCATION_TITLE: "Meeting Location",
  MEETING_LOCATION_DESC:
    "Customize the texts and visibility of the different fields that appear on your booking page(s)",
  HIDE_CREATOR_ADDRESS_TITLE: "Hide your personal addresss",
  HIDE_CREATOR_ADDRESS_DESC:
    "Toggle this on to hide your address when 'At my personal address' is selected as the meeting location.",
  HIDE_CREATOR_ADDRESS_REF_TITLE: "Hide your personal address",
  HIDE_CREATOR_ADDRESS_REF_DESC:
    "This text appears on the event page when ’At my personal address’ is selected as the meeting location.",
  PERSONAL_ADDRESS_TITLE: "Edit 'At my personal address' text",
  PERSONAL_ADDRESS_DESC:
    "This text appears on the event page when ’At my personal address’ is selected as the meeting location.",
  PERSONAL_ADDRESS_DEFAULT: "At my personal address",
  PERSONAL_ADDRESS_REF_TITLE: "At my personal address",
  PERSONAL_ADDRESS_REF_DESC:
    "This text appears on the event page when ’At my personal address’ is selected as the meeting location.",
  PHONE_TITLE: "Edit 'Phone' section text",
  PHONE_DESC:
    "Appears on the event page when 'Phone' is selected as the meeting location.",
  PHONE_DEFAULT: "Call on phone",
  PHONE_PLACEHOLDER: "Enter Text",
  PHONE_REF_TITLE: "Phone title",
  PHONE_REF_DESC:
    "This text appears on the event page when 'Phone' is selected as the meeting location.",
  PHONE_DESCRIPTION_TITLE: "Edit 'Phone' description text",
  PHONE_DESCRIPTION_DESC:
    "Appears below the 'Phone' header when 'Phone' is selected as the meeting location.",
  PHONE_DESCRIPTION_PLACEHOLDER: "Enter text",
  PHONE_DESCRIPTION_REF_TITLE: "Phone description",
  PHONE_DESCRIPTION_REF_DESC:
    "This text appears on the event page as description, when 'Phone' is selected as the meeting location.",

  // Trust Markers
  TRUST_MARKERS_TITLE: "Trust Markers",
  TRUST_MARKERS_DESC:
    "Trust markers build credibility and reassure customers, encouraging bookings.",
  HIDE_TRUST_MARKERS_TITLE: "Hide trust markers",
  HIDE_TRUST_MARKERS_DESC:
    "Your page visitors will not be able to see any trust-building icons from your event page.",
  TRUST_MARKERS_REF_TITLE: "Trust Markers",
  TRUST_MARKERS_REF_DESC:
    "Trust markers are present on your offering pages. They build credibility, reassure visitors about the site's legitimacy and encourage actions like purchases.",

  // Reviews
  REVIEWS_TITLE: "Reviews",
  REVIEWS_DESC:
    "Customize how viewers receive the offering by managing the reviews they see.",
  ADD_REVIEW_TITLE: "Add new custom review",
  ADD_REVIEW_DESC:
    "Add custom reviews to impress users, build credibility, and boost sales.",
  REVIEWS_REF_TITLE: "Reviews",
  REVIEWS_REF_DESC:
    "This section appears below your offering description. It only appears if you add any reviews or testimonials for display. It helps build trust with the viewer and propose money value.",
  MANAGE_REVIEWS_TITLE: "Manage custom reviews",
  MANAGE_REVIEWS_DESC: "Edit or manage custom reviews.",
  MANAGE_REVIEWS_BTN: "Manage reviews",

  // Share Event
  SHARE_EVENT_TITLE: "Share Event",
  SHARE_EVENT_DESC:
    "Customize the share button that appears on your event page.",
  SHARE_CTA_TITLE: "Edit 'Share event' button text",
  SHARE_CTA_DESC:
    "This button appears below your offering reviews on the event page and lets visitors share the offering link.",
  SHARE_CTA_DEFAULT: "Share event",
  SHARE_CTA_REF_TITLE: "Share event",
  SHARE_CTA_REF_DESC:
    "This button appears on the event page, below your offering reviews. It provides the visitor with an offering link to share.",

  // Meet Your Creator
  MEET_CREATOR_TITLE: "Meet Your Creator",
  MEET_CREATOR_DESC: "Customize the section where your details are displayed.",
  MEET_CREATOR_HEADER_TITLE: "Edit 'Meet your creator' section header",
  MEET_CREATOR_HEADER_DESC:
    "This header text appears on the event page, where your details are shown.",
  MEET_CREATOR_HEADER_DEFAULT: "Meet your creator",
  MEET_CREATOR_HEADER_REF_TITLE: "Creator Intro",
  MEET_CREATOR_HEADER_REF_DESC:
    "This text 'Meet your creator' appears on your website and offerings pages. It helps make an impactful introduction to your visitors.",
  VISIT_WEBSITE_TITLE: "Edit 'Visit website' button text",
  VISIT_WEBSITE_DESC:
    "This button appears on the event page, below your details. It redirects users to your website.",
  VISIT_WEBSITE_DEFAULT: "Visit website",
  VISIT_WEBSITE_REF_TITLE: "Visit website",
  VISIT_WEBSITE_REF_DESC:
    "This button appears on the event page, below your own details. It redirects users to your website.",
  CONTACT_CREATOR_TITLE: "Edit 'Contact creator' button text",
  CONTACT_CREATOR_DESC:
    "This button appears below your details on the event page and opens the contact form.",
  CONTACT_CREATOR_DEFAULT: "Contact creator",
  CONTACT_CREATOR_REF_TITLE: "Contact creator",
  CONTACT_CREATOR_REF_DESC:
    "This button appears on the event page, below your details. It opens the contact form for the user.",

  // Certificate
  CERTIFICATE_TITLE: "Certificate",
  CERTIFICATE_DESC:
    "Customize the certificate text that appears on your event page.",
  CUSTOM_CERTIFICATE_TITLE: "Edit 'Get certified!' section header",
  CUSTOM_CERTIFICATE_DESC:
    "This header text appears on the event page, where your certificate is displayed.",
  CUSTOM_CERTIFICATE_DEFAULT: "Get certified!",
  CUSTOM_CERTIFICATE_REF_TITLE: "Certificate",
  CUSTOM_CERTIFICATE_REF_DESC:
    "This text 'Get certified!' appears on the event page, where your certificate is displayed. This only appears if your offering is a Recorded Content. It helps showcase value for money and bump sales.",

  // FAQs
  FAQS_TITLE: "Frequently Asked Questions",
  FAQS_DESC:
    "Answer common event-related questions for viewers and reduce the need for support.",
  ADD_FAQ_TITLE: "Add new question",
  ADD_FAQ_DESC:
    "Add FAQs to address concerns and clarify potential doubts for viewers.",
  FAQS_REF_TITLE: "FAQs",
  FAQS_REF_DESC:
    "The FAQs appear at the end of your offering pages. They help address concerns and clarify potential doubts for viewers.",
  MANAGE_FAQS_TITLE: "Manage all questions",
  MANAGE_FAQS_DESC: "Edit or manage FAQs.",
  MANAGE_FAQS_BTN: "Manage FAQs",

  // Booking Popup Details
  BOOKING_POPUP_TITLE: "Booking Popup Details",
  BOOKING_POPUP_DESC:
    "Customize your offering's booking popup fields and button.",
  BOOKING_CTA_TITLE: "Edit 'Book now' button text",
  BOOKING_CTA_DESC:
    "The customer will click on this button to open the booking popup.",
  BOOKING_CTA_DEFAULT: "Book now",
  BOOKING_CTA_REF_TITLE: "Book now button",
  BOOKING_CTA_REF_DESC:
    "This button appears on your event page. The customer will click on this button to open the booking popup.",
  BOOKING_POPUP_HEADER_TITLE: "Edit booking popup title",
  BOOKING_POPUP_HEADER_DESC:
    "This title will appear at the top of your booking popup.",
  BOOKING_POPUP_HEADER_DEFAULT: "Where do we contact you?",
  BOOKING_POPUP_HEADER_REF_TITLE: "Booking popup title",
  BOOKING_POPUP_HEADER_REF_DESC:
    "This text appears in your booking popup where the customer enters their personal details before payment.",
  INITIATE_BOOKING_TITLE: "Edit 'Initiate Booking' button text",
  INITIATE_BOOKING_DESC:
    "The customer will fill all their details and click on this button to proceed for payment.",
  INITIATE_BOOKING_DEFAULT: "Initiate Booking",
  INITIATE_BOOKING_REF_TITLE: "Booking popup button",
  INITIATE_BOOKING_REF_DESC:
    "This button appears in your booking popup where the customer enters their personal details before payment. They will click on this button to proceed to payment gateway.",
  TERMS_CONDITIONS_TITLE: "Show 'Terms & Conditions' before booking",
  TERMS_CONDITIONS_DESC:
    "Add a T&C URL for customers to view and acknowledge before booking.",
  TERMS_CONDITIONS_PLACEHOLDER: "Paste URL",
  TERMS_CONDITIONS_FOOTER: "Currently, not only supported for checkout pages.",
  TERMS_CONDITIONS_REF_TITLE: "Terms and Conditions",
  TERMS_CONDITIONS_REF_DESC:
    "This URL will be displayed in the booking popup as a hyperlink for 'Terms and Conditions'. Visitors will need to acknowledge the same to be able to book.",
};

export const EVENT_PAGE_DETAILS_CONFIG = [
  {
    key: PAGE_SECTIONS_KEYS.ABOUT_OFFERINGS,
    title: PAGE_SECTIONS_TEXTS.ABOUT_OFFERINGS_TITLE,
    description: PAGE_SECTIONS_TEXTS.ABOUT_OFFERINGS_DESC,
    subSectionConfig: [
      {
        title: PAGE_SECTIONS_TEXTS.OFFERING_DESC_TITLE,
        description: PAGE_SECTIONS_TEXTS.OFFERING_DESC_DESC,
        key: PAGE_SECTIONS_KEYS.OFFERING_DESC,
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        customRightJSX: (
          <ManageOfferingSwitch
            subSectionKey={PAGE_SECTIONS_KEYS.OFFERING_DESC}
            invertedMode
          />
        ),
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.OFFERING_DESC,
          url: "assets/images/manage_offerings/description_expand.png",
          height: "tw-py-[14px]",
          title: PAGE_SECTIONS_TEXTS.OFFERING_DESC_REF_TITLE,
          description: PAGE_SECTIONS_TEXTS.OFFERING_DESC_REF_DESC,
        },
      },
      {
        title: PAGE_SECTIONS_TEXTS.HIDE_WORKSHOP_TITLE,
        description: PAGE_SECTIONS_TEXTS.HIDE_WORKSHOP_DESC,
        key: PAGE_SECTIONS_KEYS.HIDE_WORKSHOP,
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        customRightJSX: (
          <ManageOfferingSwitch
            subSectionKey={PAGE_SECTIONS_KEYS.HIDE_WORKSHOP}
          />
        ),
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.HIDE_WORKSHOP,
          url: "assets/images/manage_offerings/workshop_schedule.png",
          height: "tw-py-[14px]",
          title: PAGE_SECTIONS_TEXTS.HIDE_WORKSHOP_REF_TITLE,
          description: PAGE_SECTIONS_TEXTS.HIDE_WORKSHOP_REF_DESC,
        },
      },
    ],
  },
  {
    key: PAGE_SECTIONS_KEYS.MEETING_LOCATION,
    title: PAGE_SECTIONS_TEXTS.MEETING_LOCATION_TITLE,
    description: PAGE_SECTIONS_TEXTS.MEETING_LOCATION_DESC,
    subSectionConfig: [
      {
        title: PAGE_SECTIONS_TEXTS.HIDE_CREATOR_ADDRESS_TITLE,
        description: PAGE_SECTIONS_TEXTS.HIDE_CREATOR_ADDRESS_DESC,
        key: PAGE_SECTIONS_KEYS.HIDE_CREATOR_ADDRESS,
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        customRightJSX: (
          <ManageOfferingSwitch
            subSectionKey={PAGE_SECTIONS_KEYS.HIDE_CREATOR_ADDRESS}
            invertedMode
          />
        ),
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.HIDE_CREATOR_ADDRESS,
          url: "assets/vectors/homepage/personal_add.png",
          height: "tw-py-[14px]",
          title: PAGE_SECTIONS_TEXTS.HIDE_CREATOR_ADDRESS_REF_TITLE,
          description: PAGE_SECTIONS_TEXTS.HIDE_CREATOR_ADDRESS_REF_DESC,
        },
      },
      {
        key: PAGE_SECTIONS_KEYS.PERSONAL_ADDRESS_TITLE,
        title: PAGE_SECTIONS_TEXTS.PERSONAL_ADDRESS_TITLE,
        description: PAGE_SECTIONS_TEXTS.PERSONAL_ADDRESS_DESC,
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        customRightJSX: (
          <ManageOfferingInputSubSection
            subSectionKey={PAGE_SECTIONS_KEYS.PERSONAL_ADDRESS_TITLE}
            defaultValue={PAGE_SECTIONS_TEXTS.PERSONAL_ADDRESS_DEFAULT}
            placeholder={PAGE_SECTIONS_TEXTS.PERSONAL_ADDRESS_DEFAULT}
          />
        ),
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.PERSONAL_ADDRESS_TITLE,
          url: "assets/vectors/homepage/personal_add.png",
          height: "tw-py-[14px]",
          title: PAGE_SECTIONS_TEXTS.PERSONAL_ADDRESS_REF_TITLE,
          description: PAGE_SECTIONS_TEXTS.PERSONAL_ADDRESS_REF_DESC,
        },
      },
      {
        key: PAGE_SECTIONS_KEYS.PHONE_TITLE,
        title: PAGE_SECTIONS_TEXTS.PHONE_TITLE,
        description: PAGE_SECTIONS_TEXTS.PHONE_DESC,
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        customRightJSX: (
          <ManageOfferingInputSubSection
            subSectionKey={PAGE_SECTIONS_KEYS.PHONE_TITLE}
            placeholder={PAGE_SECTIONS_TEXTS.PHONE_PLACEHOLDER}
            defaultValue={PAGE_SECTIONS_TEXTS.PHONE_DEFAULT}
          />
        ),
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.PHONE_TITLE,
          url: "assets/vectors/homepage/phone.png",
          height: "tw-h-[75px]",
          title: PAGE_SECTIONS_TEXTS.PHONE_REF_TITLE,
          description: PAGE_SECTIONS_TEXTS.PHONE_REF_DESC,
        },
      },
      {
        key: PAGE_SECTIONS_KEYS.PHONE_DECRIPTION_TITLE,
        title: PAGE_SECTIONS_TEXTS.PHONE_DESCRIPTION_TITLE,
        description: PAGE_SECTIONS_TEXTS.PHONE_DESCRIPTION_DESC,
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        customRightJSX: (
          <ManageOfferingInputSubSection
            subSectionKey={PAGE_SECTIONS_KEYS.PHONE_DECRIPTION_TITLE}
            placeholder={PAGE_SECTIONS_TEXTS.PHONE_DESCRIPTION_PLACEHOLDER}
          />
        ),
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.PHONE_DECRIPTION_TITLE,
          url: "assets/vectors/homepage/phone.png",
          height: "tw-h-[75px]",
          title: PAGE_SECTIONS_TEXTS.PHONE_DESCRIPTION_REF_TITLE,
          description: PAGE_SECTIONS_TEXTS.PHONE_DESCRIPTION_REF_DESC,
        },
      },
    ],
  },
  {
    key: PAGE_SECTIONS_KEYS.TRUST_MARKERS,
    title: PAGE_SECTIONS_TEXTS.TRUST_MARKERS_TITLE,
    description: PAGE_SECTIONS_TEXTS.TRUST_MARKERS_DESC,
    subSectionConfig: [
      {
        title: PAGE_SECTIONS_TEXTS.HIDE_TRUST_MARKERS_TITLE,
        description: PAGE_SECTIONS_TEXTS.HIDE_TRUST_MARKERS_DESC,
        key: PAGE_SECTIONS_KEYS.HIDE_TRUST_MARKERS,
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        customRightJSX: (
          <ManageOfferingSwitch
            subSectionKey={PAGE_SECTIONS_KEYS.HIDE_TRUST_MARKERS}
          />
        ),
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.TRUST_MARKERS,
          url: [
            "assets/vectors/homepage/trust1.png",
            "assets/vectors/homepage/trust2.png",
          ],
          height: "tw-py-[14px]",
          title: PAGE_SECTIONS_TEXTS.TRUST_MARKERS_REF_TITLE,
          description: PAGE_SECTIONS_TEXTS.TRUST_MARKERS_REF_DESC,
        },
      },
      {
        hideSubsectionText: true,
        customRightJSX: (
          <>
            <CustomImageHandlerLayout
              sectionKey={PAGE_SECTIONS_KEYS.TRUST_MARKERS}
              sectionName={SECTION_TYPES.OFFERINGS}
            />
            <SeeReferenceModal />
          </>
        ),
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
      },
    ],
  },
  {
    key: PAGE_SECTIONS_KEYS.REVIEWS,
    title: PAGE_SECTIONS_TEXTS.REVIEWS_TITLE,
    description: PAGE_SECTIONS_TEXTS.REVIEWS_DESC,
    subSectionConfig: [
      {
        title: PAGE_SECTIONS_TEXTS.ADD_REVIEW_TITLE,
        description: PAGE_SECTIONS_TEXTS.ADD_REVIEW_DESC,
        customRightJSX: <AddReviewBtn />,
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.REVIEWS,
          url: "assets/images/manage_offerings/reviews.png",
          height: "tw-h-[165px]",
          title: PAGE_SECTIONS_TEXTS.REVIEWS_REF_TITLE,
          description: PAGE_SECTIONS_TEXTS.REVIEWS_REF_DESC,
        },
      },
      {
        title: PAGE_SECTIONS_TEXTS.MANAGE_REVIEWS_TITLE,
        description: PAGE_SECTIONS_TEXTS.MANAGE_REVIEWS_DESC,
        customRightJSX: (
          <ManageOfferingsBtn
            btnText={PAGE_SECTIONS_TEXTS.MANAGE_REVIEWS_BTN}
            startIcon={RateReviewOutlined}
            action={({ listing_uuid }) => {
              navigateTo(app_route_keys.OFFERING_PUBLISHED_FEEDBACK, {
                args: {
                  listing_uuid,
                  section_key: FEEDBACK_SECTION_KEY,
                  navigate_back: true,
                },
              });
            }}
          />
        ),
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
      },
    ],
  },
  {
    title: PAGE_SECTIONS_TEXTS.SHARE_EVENT_TITLE,
    description: PAGE_SECTIONS_TEXTS.SHARE_EVENT_DESC,
    subSectionConfig: [
      {
        key: PAGE_SECTIONS_KEYS.SHARE_CTA_TEXT,
        title: PAGE_SECTIONS_TEXTS.SHARE_CTA_TITLE,
        description: PAGE_SECTIONS_TEXTS.SHARE_CTA_DESC,
        customRightJSX: (
          <ManageOfferingInputSubSection
            subSectionKey={PAGE_SECTIONS_KEYS.SHARE_CTA_TEXT}
            defaultValue={PAGE_SECTIONS_TEXTS.SHARE_CTA_DEFAULT}
            placeholder={PAGE_SECTIONS_TEXTS.SHARE_CTA_DEFAULT}
          />
        ),
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.SHARE_CTA_TEXT,
          url: "assets/vectors/homepage/sharevent.png",
          height: "tw-py-[14px]",
          title: PAGE_SECTIONS_TEXTS.SHARE_CTA_REF_TITLE,
          description: PAGE_SECTIONS_TEXTS.SHARE_CTA_REF_DESC,
        },
      },
    ],
  },
  {
    title: PAGE_SECTIONS_TEXTS.MEET_CREATOR_TITLE,
    description: PAGE_SECTIONS_TEXTS.MEET_CREATOR_DESC,
    subSectionConfig: [
      {
        key: PAGE_SECTIONS_KEYS.MEET_CREATOR_HEADER,
        title: PAGE_SECTIONS_TEXTS.MEET_CREATOR_HEADER_TITLE,
        description: PAGE_SECTIONS_TEXTS.MEET_CREATOR_HEADER_DESC,
        customRightJSX: (
          <ManageOfferingInputSubSection
            subSectionKey={PAGE_SECTIONS_KEYS.MEET_CREATOR_HEADER}
            defaultValue={PAGE_SECTIONS_TEXTS.MEET_CREATOR_HEADER_DEFAULT}
            placeholder={PAGE_SECTIONS_TEXTS.MEET_CREATOR_HEADER_DEFAULT}
          />
        ),
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.MEET_CREATOR_HEADER,
          url: "assets/vectors/homepage/meetcreator.png",
          height: "tw-py-[14px]",
          title: PAGE_SECTIONS_TEXTS.MEET_CREATOR_HEADER_REF_TITLE,
          description: PAGE_SECTIONS_TEXTS.MEET_CREATOR_HEADER_REF_DESC,
        },
      },
      {
        key: PAGE_SECTIONS_KEYS.VISIT_WEBSITE_CTA,
        title: PAGE_SECTIONS_TEXTS.VISIT_WEBSITE_TITLE,
        description: PAGE_SECTIONS_TEXTS.VISIT_WEBSITE_DESC,
        customRightJSX: (
          <ManageOfferingInputSubSection
            subSectionKey={PAGE_SECTIONS_KEYS.VISIT_WEBSITE_CTA}
            defaultValue={PAGE_SECTIONS_TEXTS.VISIT_WEBSITE_DEFAULT}
            placeholder={PAGE_SECTIONS_TEXTS.VISIT_WEBSITE_DEFAULT}
          />
        ),
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.VISIT_WEBSITE_CTA,
          url: "assets/vectors/homepage/contact_creator.png",
          height: "tw-py-[14px]",
          title: PAGE_SECTIONS_TEXTS.VISIT_WEBSITE_REF_TITLE,
          description: PAGE_SECTIONS_TEXTS.VISIT_WEBSITE_REF_DESC,
        },
      },
      {
        key: CUSTOMIZATION_SECTIONKEYS.CREATOR_CONTACT_CTA_TEXT,
        title: PAGE_SECTIONS_TEXTS.CONTACT_CREATOR_TITLE,
        description: PAGE_SECTIONS_TEXTS.CONTACT_CREATOR_DESC,
        customRightJSX: (
          <ManageOfferingInputSubSection
            subSectionKey={CUSTOMIZATION_SECTIONKEYS.CREATOR_CONTACT_CTA_TEXT}
            defaultValue={PAGE_SECTIONS_TEXTS.CONTACT_CREATOR_DEFAULT}
            placeholder={PAGE_SECTIONS_TEXTS.CONTACT_CREATOR_DEFAULT}
          />
        ),
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        seeReferenceConfig: {
          id: CUSTOMIZATION_SECTIONKEYS.CREATOR_CONTACT_CTA_TEXT,
          url: "assets/vectors/homepage/contact_creator.png",
          height: "tw-py-[14px]",
          title: PAGE_SECTIONS_TEXTS.CONTACT_CREATOR_REF_TITLE,
          description: PAGE_SECTIONS_TEXTS.CONTACT_CREATOR_REF_DESC,
        },
      },
    ],
  },
  {
    title: PAGE_SECTIONS_TEXTS.CERTIFICATE_TITLE,
    description: PAGE_SECTIONS_TEXTS.CERTIFICATE_DESC,
    subSectionConfig: [
      {
        key: PAGE_SECTIONS_KEYS.CUSTOM_CERTIFICATE_TITLE,
        title: PAGE_SECTIONS_TEXTS.CUSTOM_CERTIFICATE_TITLE,
        description: PAGE_SECTIONS_TEXTS.CUSTOM_CERTIFICATE_DESC,
        customRightJSX: (
          <ManageOfferingInputSubSection
            subSectionKey={PAGE_SECTIONS_KEYS.CUSTOM_CERTIFICATE_TITLE}
            defaultValue={PAGE_SECTIONS_TEXTS.CUSTOM_CERTIFICATE_DEFAULT}
            placeholder={PAGE_SECTIONS_TEXTS.CUSTOM_CERTIFICATE_DEFAULT}
          />
        ),
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.CUSTOM_CERTIFICATE_TITLE,
          url: "assets/images/manage_offerings/certificates.png",
          height: "tw-py-[14px]",
          title: PAGE_SECTIONS_TEXTS.CUSTOM_CERTIFICATE_REF_TITLE,
          description: PAGE_SECTIONS_TEXTS.CUSTOM_CERTIFICATE_REF_DESC,
        },
      },
    ],
  },
  {
    title: PAGE_SECTIONS_TEXTS.FAQS_TITLE,
    description: PAGE_SECTIONS_TEXTS.FAQS_DESC,
    subSectionConfig: [
      {
        key: PAGE_SECTIONS_KEYS.FAQS,
        title: PAGE_SECTIONS_TEXTS.ADD_FAQ_TITLE,
        description: PAGE_SECTIONS_TEXTS.ADD_FAQ_DESC,
        customRightJSX: <AddFaqBtn />,
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.FAQS,
          url: "assets/images/manage_offerings/faq.png",
          height: "tw-h-[125px]",
          title: PAGE_SECTIONS_TEXTS.FAQS_REF_TITLE,
          description: PAGE_SECTIONS_TEXTS.FAQS_REF_DESC,
        },
      },
      {
        title: PAGE_SECTIONS_TEXTS.MANAGE_FAQS_TITLE,
        description: PAGE_SECTIONS_TEXTS.MANAGE_FAQS_DESC,
        customRightJSX: (
          <ManageOfferingsBtn
            btnText={PAGE_SECTIONS_TEXTS.MANAGE_FAQS_BTN}
            startIcon={LiveHelpOutlined}
            action={({ listing_uuid }) => {
              navigateTo(app_route_keys.FAQS, {
                args: {
                  listing_uuid,
                },
              });
            }}
          />
        ),
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
      },
    ],
  },
];

export const OFFERING_SUBSECTION_KEYS = {
  BOOKING_POPUP_DETAILS: "booking_popup_details",
  VERIFICATION_AT_CHECKOUT: "verification_at_checkout",
};

export const KYC_TYPE_CONFIG = {
  key: PAGE_SECTIONS_KEYS.KYC_TYPE,
  title: "KYC Verification",
  description:
    "Choose the method used to verify customer identity for KYC compliance.",
  customRightJSX: (
    <KYCTypeSubsection subSectionKey={PAGE_SECTIONS_KEYS.KYC_TYPE} />
  ),
  permissionKey: FEATURE_KEYS.KRA_FLOW,
  lockCustomRightJSX: (
    <ManageOfferingsLockBtn btnText="Upgrade Plan" action={openPricingPage} />
  ),
  classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
};

export const BOOKING_DETAILS_CONFIG = [
  {
    id: OFFERING_SUBSECTION_KEYS.BOOKING_POPUP_DETAILS,
    title: PAGE_SECTIONS_TEXTS.BOOKING_POPUP_TITLE,
    description: PAGE_SECTIONS_TEXTS.BOOKING_POPUP_DESC,
    subSectionConfig: [
      {
        key: PAGE_SECTIONS_KEYS.BOOKING_CTA_TEXT,
        title: PAGE_SECTIONS_TEXTS.BOOKING_CTA_TITLE,
        description: PAGE_SECTIONS_TEXTS.BOOKING_CTA_DESC,
        customRightJSX: (
          <ManageOfferingInputSubSection
            subSectionKey={PAGE_SECTIONS_KEYS.BOOKING_CTA_TEXT}
            defaultValue={PAGE_SECTIONS_TEXTS.BOOKING_CTA_DEFAULT}
            placeholder={PAGE_SECTIONS_TEXTS.BOOKING_CTA_DEFAULT}
          />
        ),
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.BOOKING_CTA_TEXT,
          url: "assets/images/manage_offerings/book_now.png",
          height: "tw-py-[14px]",
          title: PAGE_SECTIONS_TEXTS.BOOKING_CTA_REF_TITLE,
          description: PAGE_SECTIONS_TEXTS.BOOKING_CTA_REF_DESC,
        },
      },
      {
        key: PAGE_SECTIONS_KEYS.BOOKING_TITLE,
        title: PAGE_SECTIONS_TEXTS.BOOKING_POPUP_HEADER_TITLE,
        description: PAGE_SECTIONS_TEXTS.BOOKING_POPUP_HEADER_DESC,
        customRightJSX: (
          <ManageOfferingInputSubSection
            subSectionKey={PAGE_SECTIONS_KEYS.BOOKING_TITLE}
            defaultValue={PAGE_SECTIONS_TEXTS.BOOKING_POPUP_HEADER_DEFAULT}
            placeholder={PAGE_SECTIONS_TEXTS.BOOKING_POPUP_HEADER_DEFAULT}
          />
        ),
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.BOOKING_TITLE,
          url: "assets/images/manage_offerings/initate_booking.png",
          height: "tw-py-[14px]",
          title: PAGE_SECTIONS_TEXTS.BOOKING_POPUP_HEADER_REF_TITLE,
          description: PAGE_SECTIONS_TEXTS.BOOKING_POPUP_HEADER_REF_DESC,
        },
      },
      {
        key: PAGE_SECTIONS_KEYS.INITIATE_BOOKING_CTA_TEXT,
        title: PAGE_SECTIONS_TEXTS.INITIATE_BOOKING_TITLE,
        description: PAGE_SECTIONS_TEXTS.INITIATE_BOOKING_DESC,
        customRightJSX: (
          <ManageOfferingInputSubSection
            subSectionKey={PAGE_SECTIONS_KEYS.INITIATE_BOOKING_CTA_TEXT}
            defaultValue={PAGE_SECTIONS_TEXTS.INITIATE_BOOKING_DEFAULT}
            placeholder={PAGE_SECTIONS_TEXTS.INITIATE_BOOKING_DEFAULT}
          />
        ),
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.INITIATE_BOOKING_CTA_TEXT,
          url: "assets/images/manage_offerings/initate_booking.png",
          height: "tw-py-[14px]",
          title: PAGE_SECTIONS_TEXTS.INITIATE_BOOKING_REF_TITLE,
          description: PAGE_SECTIONS_TEXTS.INITIATE_BOOKING_REF_DESC,
        },
      },
    ],
  },
  {
    id: OFFERING_SUBSECTION_KEYS.VERIFICATION_AT_CHECKOUT,
    title: "Verification at checkout",
    description:
      "Show necessary ‘Terms and conditions’ for customers to view and acknowledge at checkout.",
    customWhitelabelLock: <WhitelabelFeatureCard />,
    subSectionConfig: [
      {
        key: PAGE_SECTIONS_KEYS.CUSTOM_TNC_LABEL,
        title: "Edit Terms & Condition statement",
        description:
          "The customer will see this text when they fill all their details and are about to proceed for payment. ",
        customRightJSX: (
          <ManageOfferingInputSubSection
            subSectionKey={PAGE_SECTIONS_KEYS.CUSTOM_TNC_LABEL}
            defaultValue=""
            placeholder="Edit statement"
            validate={cannotBeEmpty}
          />
        ),
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.CUSTOM_TNC_LABEL,
          url: "assets/images/manage_offerings/tnc.png",
          height: "tw-h-[128px]",
          title: "Edit Terms & Condition statement",
          description:
            "The customer will be able to view this by clicking on the info icon at the end of the above text.",
        },
      },
      {
        key: PAGE_SECTIONS_KEYS.CUSTOM_TNC,
        title: "Add Terms & Condition",
        description:
          "The customer will be able to view this by clicking on the info icon at the end of the above text.",
        customRightJSX: (
          <ManageOfferingInputSubSection
            subSectionKey={PAGE_SECTIONS_KEYS.CUSTOM_TNC}
            defaultValue=""
            placeholder="Add Terms & Condition"
            validate={(value) => {
              if (!value) return null;
              if (!validURLV2(value)) {
                return "Please enter a valid URL";
              }
              return null;
            }}
          />
        ),
        classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
        seeReferenceConfig: {
          id: PAGE_SECTIONS_KEYS.CUSTOM_TNC,
          url: "assets/images/manage_offerings/tnc.png",
          height: "tw-h-[128px]",
          title: "Add Terms & Condition",
          description:
            "The customer will be able to view this by clicking on the info icon at the end of the above text",
        },
      },
      { ...KYC_TYPE_CONFIG },
    ],
  },
];

export const KRA_WORKFLOW_CONFIG = {
  key: PAGE_SECTIONS_KEYS.IS_DIGIO_KYC_ENABLED,
  title: "Enable KRA Workflow",
  description: "Enable KRA Workflow for this offering.",
  customRightJSX: (
    <ManageOfferingSwitch
      subSectionKey={PAGE_SECTIONS_KEYS.IS_DIGIO_KYC_ENABLED}
    />
  ),
  permissionKey: FEATURE_KEYS.KRA_FLOW,
  lockCustomRightJSX: (
    <ManageOfferingsLockBtn btnText="Upgrade Plan" action={openPricingPage} />
  ),
  classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
};

export const CONTRACT_REDIRECTION_CONFIG = ({
  endPoint = UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL,
}) => {
  return {
    key: PAGE_SECTIONS_KEYS.CONTRACT_PDF_URL,
    title: "Add contract for redirection",
    description:
      "The customer will be able to view this by clicking on the info icon at the end of the above text.",
    customRightJSX: (
      <ManageContractInputSubSection
        subSectionKey={PAGE_SECTIONS_KEYS.CONTRACT_PDF_URL}
        defaultValue=""
        placeholder="Paste URL"
        fileNameLabel="Aadhaar Contract"
        endPoint={endPoint}
      />
    ),
    permissionKey: FEATURE_KEYS.KRA_FLOW,
    lockCustomRightJSX: (
      <ManageOfferingsLockBtn btnText="Upgrade Plan" action={openPricingPage} />
    ),
    classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
    seeReferenceConfig: {
      id: PAGE_SECTIONS_KEYS.CONTRACT_PDF_URL,
      url: "assets/images/manage_offerings/kyc_popup.png",
      height: "tw-h-[535px]",
      title: "Add contract for redirection",
      description:
        "This contract enables customers to complete KYC using Aadhaar eSign.",
    },
  };
};

export const KRA_CONTRACT_CONFIG = {
  key: PAGE_SECTIONS_KEYS.KRA_CONTRACT_URL,
  title: "Add KRA Contract for redirection (Optional)",
  description:
    "The customer will be able to view this by clicking on the info icon at the end of the above text.",
  customRightJSX: (
    <ManageContractInputSubSection
      subSectionKey={PAGE_SECTIONS_KEYS.KRA_CONTRACT_URL}
      defaultValue=""
      placeholder="Paste URL"
      fileNameLabel="KRA Contract"
      multiUpload={[
        {
          btnText: "Upload NDML/CDL Customer Registration Form",
          fileLabel: "NDML/CDL Customer Registration Form",
        },
        {
          btnText: "Upload Contract",
          fileLabel: "Contract",
        },
      ]}
    />
  ),
  permissionKey: FEATURE_KEYS.KRA_FLOW,
  lockCustomRightJSX: (
    <ManageOfferingsLockBtn btnText="Upgrade Plan" action={openPricingPage} />
  ),
  classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
  lockedStatesArr: [],
  customFooter: <KRAContractFooter />,
};

export const ESIGN_CONFIG = ({
  endPoint = UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL,
}) => {
  return {
    key: PAGE_SECTIONS_KEYS.IS_ESIGN_ENABLED,
    title: "Enable Aadhaar e-signing of contract",
    description:
      "The customer will be required to e-sign the above contract using Aadhaar, at checkout.",
    customRightJSX: (
      <ManageOfferingSwitch
        subSectionKey={PAGE_SECTIONS_KEYS.IS_ESIGN_ENABLED}
        endPoint={endPoint}
      />
    ),
    classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
    permissionKey: FEATURE_KEYS.KRA_FLOW,
    lockCustomRightJSX: (
      <ManageOfferingsLockBtn btnText="Upgrade Plan" action={openPricingPage} />
    ),
  };
};

export const ESIGN_PLACEMENT_CONFIG = ({
  endPoint = UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL,
}) => {
  return {
    key: PAGE_SECTIONS_KEYS.ESIGN_PLACEMENT,
    title: "When to perform e-signing of contract?",
    description:
      "The customer will find this contract at checkout, either before or after the booking as per your selection. ",
    customRightJSX: (
      <ESignPlacementSubSection
        subSectionKey={PAGE_SECTIONS_KEYS.ESIGN_PLACEMENT}
        endPoint={endPoint}
      />
    ),
    permissionKey: FEATURE_KEYS.KRA_FLOW,
    lockCustomRightJSX: (
      <ManageOfferingsLockBtn btnText="Upgrade Plan" action={openPricingPage} />
    ),
    classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
  };
};

export const ESIGN_PLACEMENT_OPTIONS = [
  {
    label: "Before Booking",
    value: ESIGN_PLACEMENT.BEFORE_BOOKING,
  },
  {
    label: "After Booking",
    value: ESIGN_PLACEMENT.AFTER_BOOKING,
  },
];

export const KYC_FREQUENCY_TEXTS = {
  CREATOR_TITLE: "Apply KYC condition",
  CREATOR_DESC:
    "Choose how often your customers need to complete verification across all your offerings.",
  OFFERING_TITLE: "Apply KYC condition for this offering",
  OFFERING_DESC:
    "Choose how often customers need to complete verification for this offering.",
};

export const KYC_FREQUENCY_CREATOR_OPTIONS = [
  {
    label: "Only once per customer, across all offerings",
    value: KYC_FREQUENCY.CUSTOMER_ONCE,
  },
  {
    label: "First transaction of every offering",
    value: KYC_FREQUENCY.PER_OFFERING_ONCE,
  },
  {
    label: "Every transaction",
    value: KYC_FREQUENCY.EVERY_TXN,
  },
];

export const KYC_FREQUENCY_OFFERING_OPTIONS = [
  {
    label: "Use creator default",
    value: KYC_FREQUENCY.INHERIT,
  },
  {
    label: "First transaction for this offering",
    value: KYC_FREQUENCY.PER_OFFERING_ONCE,
  },
  {
    label: "Every transaction, including renewals",
    value: KYC_FREQUENCY.EVERY_TXN,
  },
];

export const KYC_FREQUENCY_CONFIG = ({
  endPoint = UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL,
  options = KYC_FREQUENCY_OFFERING_OPTIONS,
  defaultValue = KYC_FREQUENCY.INHERIT,
  title = KYC_FREQUENCY_TEXTS.OFFERING_TITLE,
  description = KYC_FREQUENCY_TEXTS.OFFERING_DESC,
}) => {
  return {
    key: PAGE_SECTIONS_KEYS.KYC_FREQUENCY,
    title,
    description,
    customRightJSX: (
      <KycFrequencySubSection
        subSectionKey={PAGE_SECTIONS_KEYS.KYC_FREQUENCY}
        endPoint={endPoint}
        options={options}
        defaultValue={defaultValue}
      />
    ),
    classes: { subSectionInnerWrapper: "nextLineSubSectionWrapper" },
    permissionKey: FEATURE_KEYS.KRA_FLOW,
    lockCustomRightJSX: (
      <ManageOfferingsLockBtn btnText="Upgrade Plan" action={openPricingPage} />
    ),
  };
};
